const styles = () => ({
    input: {
        borderRadius: '50px',
        padding: 0,
    },
    container: {
        display: 'flex',
    },
    clearButton: {
        padding: 0,
    },
});

export default styles;
